// Penny the parrot — the SpeakEasy mascot, reskinned bright + bouncy.
// Use on empty states, onboarding, celebrations, correct/incorrect feedback.
//
// Props:
//   size:    number  (default 120)
//   mood:    "default" | "listening" | "happy" | "sad" | "celebrate"
//   animate: bool — idle bob / celebrate hop (default true)

const GREEN = "#58cc02";
const GREEN_DK = "#4b9000";
const BELLY = "#d7ffb8";
const BEAK = "#ffc800";
const BEAK_DK = "#ff9600";

export default function Mascot({ size = 120, mood = "default", animate = true }) {
  let eyes;
  switch (mood) {
    case "happy":
    case "celebrate":
      eyes = (
        <>
          <path d="M80 78 Q88 70 96 78" stroke="#202f36" strokeWidth="4" strokeLinecap="round" fill="none" />
          <path d="M112 78 Q120 70 128 78" stroke="#202f36" strokeWidth="4" strokeLinecap="round" fill="none" />
        </>
      );
      break;
    case "sad":
      eyes = (
        <>
          <circle cx="88" cy="80" r="7" fill="#202f36" />
          <circle cx="120" cy="80" r="7" fill="#202f36" />
          <path d="M78 66 Q88 72 96 68" stroke="#202f36" strokeWidth="3" strokeLinecap="round" fill="none" />
          <path d="M112 68 Q120 72 130 66" stroke="#202f36" strokeWidth="3" strokeLinecap="round" fill="none" />
        </>
      );
      break;
    case "listening":
      eyes = (
        <>
          <circle cx="88" cy="78" r="8" fill="#fff" />
          <circle cx="120" cy="78" r="8" fill="#fff" />
          <circle cx="90" cy="79" r="5" fill="#202f36" />
          <circle cx="122" cy="79" r="5" fill="#202f36" />
        </>
      );
      break;
    default:
      eyes = (
        <>
          <circle cx="88" cy="78" r="9" fill="#fff" />
          <circle cx="120" cy="78" r="9" fill="#fff" />
          <circle cx="89" cy="79" r="5.5" fill="#202f36" />
          <circle cx="121" cy="79" r="5.5" fill="#202f36" />
          <circle cx="91" cy="76" r="2" fill="#fff" />
          <circle cx="123" cy="76" r="2" fill="#fff" />
        </>
      );
  }

  const mouth =
    mood === "celebrate" ? (
      <ellipse cx="104" cy="100" rx="10" ry="8" fill={BEAK_DK} />
    ) : mood === "sad" ? (
      <path d="M96 102 Q104 96 112 102" stroke={BEAK_DK} strokeWidth="4" strokeLinecap="round" fill="none" />
    ) : null;

  const tilt = mood === "listening" ? "rotate(-8 104 90)" : "";
  const animClass = !animate ? "" : mood === "celebrate" ? "anim-tada" : "anim-bob";

  return (
    <span className={animClass} style={{ display: "inline-block", lineHeight: 0 }}>
      <svg width={size} height={size} viewBox="0 0 208 208" fill="none" aria-hidden="true">
        {/* celebrate sparkles */}
        {mood === "celebrate" && (
          <g fill={BEAK}>
            <path d="M30 40 l3 8 8 3 -8 3 -3 8 -3 -8 -8 -3 8 -3z" />
            <path d="M176 54 l2.5 6 6 2.5 -6 2.5 -2.5 6 -2.5 -6 -6 -2.5 6 -2.5z" />
          </g>
        )}
        <g transform={tilt}>
          {/* tail */}
          <path d="M104 168 Q92 192 86 204 M104 170 Q104 194 104 206 M104 168 Q116 192 122 204"
                stroke={GREEN_DK} strokeWidth="8" strokeLinecap="round" fill="none" />
          {/* body */}
          <ellipse cx="104" cy="128" rx="50" ry="56" fill={GREEN} />
          <ellipse cx="104" cy="138" rx="30" ry="40" fill={BELLY} />
          {/* wing */}
          <path d="M62 110 Q48 138 66 168 Q82 156 86 132 Q80 114 62 110 Z" fill={GREEN_DK} />
          {/* feet */}
          <path d="M92 180 L92 190 M86 190 L98 190" stroke={BEAK_DK} strokeWidth="4" strokeLinecap="round" />
          <path d="M116 180 L116 190 M110 190 L122 190" stroke={BEAK_DK} strokeWidth="4" strokeLinecap="round" />
          {/* head */}
          <circle cx="104" cy="74" r="42" fill={GREEN} />
          {/* head tuft */}
          <path d="M96 34 Q92 22 102 26 Q106 18 110 28 Q118 20 116 34"
                stroke={GREEN} strokeWidth="7" strokeLinecap="round" fill="none" />
          {/* cheeks */}
          <circle cx="74" cy="92" r="8" fill={BELLY} opacity="0.85" />
          <circle cx="134" cy="92" r="8" fill={BELLY} opacity="0.85" />
          {/* beak */}
          <path d="M96 86 Q104 100 112 86 Q104 92 96 86 Z" fill={BEAK_DK} />
          <path d="M94 84 Q104 78 114 84 Q104 90 94 84 Z" fill={BEAK} />
          {eyes}
          {mouth}
        </g>
        {/* listening sound waves */}
        {mood === "listening" && (
          <g stroke={GREEN} fill="none" strokeLinecap="round">
            <path d="M176 78 Q186 100 176 122" strokeWidth="3.5" opacity="0.8" />
            <path d="M188 66 Q204 100 188 134" strokeWidth="3.5" opacity="0.5" />
          </g>
        )}
      </svg>
    </span>
  );
}
